"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="call-to-action" ref={ref} className={`bg-background py-12 md:py-9 lg:py-12 transition-opacity duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="container mx-auto px-4 text-center">
        <div className="flex flex-col items-center gap-8">
          {}
          <span className="text-sm font-medium tracking-[0.2em] text-foreground uppercase font-sans">
            DESCUBRE MÁS
          </span>

          {}
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
            <Button asChild className="h-auto px-10 py-2 rounded-lg bg-primary text-secondary font-sans font-semibold text-base hover:bg-primary-600 transition-colors duration-300 w-full sm:w-auto">
              <Link to="/HayaTastingPage">Catas en La Haya</Link>
            </Button>

            <Button asChild className="h-auto px-10 py-2 rounded-lg bg-primary text-secondary font-sans font-semibold text-base hover:bg-primary-600 transition-colors duration-300 w-full sm:w-auto">
              <Link to="/ForStoresPage">Información para tiendas</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}